<template>
  <header class="std-header">
    <button @click="goDashboard" class="logo-btn" aria-label="Go to dashboard">
      <img src="/earworm.png" alt="Logo" />
    </button>
    <h1 class="header-title">{{ title }}</h1>
    
    <!-- Network Status Indicator -->
    <div class="network-status" :class="{ 'offline': !isOnline }">
      <span v-if="!isOnline" class="offline-indicator" title="You are offline">📱 Offline</span>
      <span v-else class="online-indicator" title="You are online">🌐</span>
    </div>
    
    <div class="header-actions">
      <div class="user-menu">
        <button type="button" class="user-menu-btn" @click="toggleMenu" aria-label="User menu">
          <img v-if="user?.profileImageDataUrl" :src="user.profileImageDataUrl" alt="Profile" style="width:40px;height:40px;border-radius:50%;object-fit:cover;" />
          <span v-else class="avatar-initials" style="width:40px;height:40px;border-radius:50%;background:#eee;display:flex;align-items:center;justify-content:center;font-weight:600;color:#666;">
            {{ getUserInitial() }}
          </span>
        </button>
        <div v-if="menuOpen" class="user-dropdown">
          <ul>
            <li><button @click="goProfile">{{ getUserDisplayName() }}</button></li>
            <li><button @click="logout">Logout</button></li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
const props = defineProps<{ title: string, user: any }>()
const router = useRouter()

const isOnline = ref(navigator.onLine)

// Add console logging when component mounts
onMounted(() => {
  console.log('Header component mounted with user:', props.user);
  
  // Listen for network status changes
  window.addEventListener('online', () => {
    isOnline.value = true
    console.log('🌐 Back online')
  })
  
  window.addEventListener('offline', () => {
    isOnline.value = false
    console.log('📱 Gone offline')
  })
});
const menuOpen = ref(false)
const toggleMenu = () => { menuOpen.value = !menuOpen.value }
const goDashboard = () => { router.push('/dashboard') }
const goProfile = () => {
  if (props.user?.id) router.push({ name: 'edit-user', params: { id: props.user.id } })
}

const getUserInitial = () => {
  console.log('getUserInitial - user:', props.user)
  const name = props.user?.name
  const email = props.user?.email
  console.log('getUserInitial - name:', name, 'email:', email)
  
  if (name && name.trim()) {
    return name.trim().charAt(0).toUpperCase()
  }
  if (email && email.trim()) {
    return email.trim().charAt(0).toUpperCase()
  }
  return 'U'
}

const getUserDisplayName = () => {
  console.log('getUserDisplayName - user:', props.user)
  const name = props.user?.name
  const email = props.user?.email
  console.log('getUserDisplayName - name:', name, 'email:', email)
  
  if (name && name.trim()) {
    return name.trim()
  }
  if (email && email.trim()) {
    return email.trim()
  }
  return 'Profile'
}

const logout = () => {
  sessionStorage.removeItem('currentUser')
  router.push('/')
}
</script>

<style scoped>
.std-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding: 0.5rem 1.5rem;
  border-bottom: 1px solid #ddd;
}
.logo-btn {
  background: transparent;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.logo-btn img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}
.header-title {
  flex: 1;
  text-align: center;
  font-size: 1.25rem;
  color: #333;
  font-weight: 500;
  margin: 0;
}
.header-actions {
  display: flex;
  align-items: center;
}
.user-menu {
  position: relative;
}
.user-menu-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}
.user-dropdown {
  position: absolute;
  top: 110%;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  min-width: 120px;
  z-index: 10;
}
.user-dropdown ul {
  list-style: none;
  margin: 0;
  padding: 0.5rem 0;
}
.user-dropdown li {
  padding: 0.5rem 1rem;
}
.user-dropdown button {
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  padding: 0;
  font-size: 1rem;
  color: #333;
  cursor: pointer;
}
.user-dropdown button:hover {
  background: #f5f5f5;
}

.network-status {
  display: flex;
  align-items: center;
  margin: 0 1rem;
  font-size: 0.9rem;
}

.offline-indicator {
  color: #fd7e14;
  font-weight: 500;
  background: rgba(253, 126, 20, 0.1);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  border: 1px solid rgba(253, 126, 20, 0.3);
}

.online-indicator {
  color: #28a745;
  opacity: 0.7;
}

@media (max-width: 768px) {
  .network-status {
    margin: 0 0.5rem;
  }
  
  .offline-indicator {
    font-size: 0.8rem;
    padding: 0.2rem 0.4rem;
  }
}
</style>
